import { Breakpoint } from "@mui/material";

type VIEWPROPS = {
  PHONE: Breakpoint,
  TABLET: Breakpoint,
  BIG_TABLET: Breakpoint,
  DESKTOP: Breakpoint
}

export const VIEW: VIEWPROPS = {
  PHONE: 'xs',
  TABLET: 'sm',
  BIG_TABLET: 'md',
  DESKTOP: 'lg'
}